import { CTAJotaPro, HamburguerMenu, HeaderBase } from '.'
import EditorialsComponent from './EditorialsComponent'
import { HeaderContainer, HeaderStyle } from './Header.styled'
import { useDispatch, useSelector } from 'react-redux'
import { FC, useEffect, useState } from 'react'
import { fetchAuthedUser } from '../../../api/ducks/auth'
import { AppDispatch } from '../../../api/types/auth'
import { StoreType } from '../../../api/types/store'
import useScrollPosition from '@App/libs/hooks/useScroll'
import { headerInterface } from '@App/libs/interfaces/global.interface'
import { SCROLL_LIMIT_NORMAL } from '@App/libs/utils/constants/global'
import BannerTopComponent from './BannerTop.component'
import AdminToolbar from '../admin-toolbar'
import { useRouter } from 'next/router'
import AlertJota from '../AlertJota.component'
import { usePathname } from 'next/navigation'

/**
 * Header Component
 * @return {React.JSX.Element}
 */
const HeaderComponent: FC<headerInterface> = ({
    wpMenu,
    ctaPRO,
    showAcessibility,
    signupLink,
    pageTributos = false,
    bannerTop = null,
    post = false,
    headerPageContentType,
    headerPageContentId
}): React.JSX.Element => {
    const dispatch = useDispatch<AppDispatch>()
    const scrollPosition = useScrollPosition()
    const [hasEditorAccess, setHasEditorAccess] = useState<boolean>(false)
    const [isLogged, setIsLogged] = useState<boolean>(false)
    const [scroll, setScroll] = useState(false)
    const [marginTop, setMarginTop] = useState(0)
    const router = useRouter()
    const isPreviewSheet = usePathname()?.includes('preview')
    const [isPreviewNews, setIsPreviewNews] = useState(false)
    const { auth, ui } = useSelector((state: StoreType) => state)

    useEffect(() => {
        if (router.query.p) {
            const page = Number(router.query.p)
            if (!isNaN(page)) {
                window.location.href = '/redirect?p=' + page
            }
        }
    }, [router.query.p])

    useEffect(() => {
        dispatch(fetchAuthedUser())
    }, [dispatch])

    useEffect(() => {
        const user: any = auth.user?.getUserBO()
        setIsLogged(!!user?.id)
        setHasEditorAccess(
            user?.email.includes('@jota.info') ||
                user?.role?.some(
                    (role: string) =>
                        role === 'administrator' || role === 'editor'
                )
        )
        if (
            auth.authState == 'NOT_LOGGED' &&
            (isPreviewSheet || isPreviewNews)
        ) {
            redirect()
        }
    }, [auth.user, isPreviewNews])

    useEffect(() => {
        if (router.isReady) {
            setIsPreviewNews(router.query.preview === 'true')
        }
    }, [router.isReady, router.query.preview])

    useEffect(() => {
        if (hasEditorAccess && ctaPRO.enabled) {
            setMarginTop(10)
        } else if (hasEditorAccess || ctaPRO.enabled) {
            setMarginTop(8)
        }

        const handleScroll = () => {
            const scrollTop = window.scrollY

            setScroll(scrollTop > 0)
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [ctaPRO.enabled, hasEditorAccess])

    /**
     * Redireciona o usuário para a homepage quando a tela é Preview e o usuário não autenticado.
     */
    function redirect() {
        router.push('/')
    }

    return (
        <HeaderStyle
            data-testid='header-container'
            scroll={scrollPosition > SCROLL_LIMIT_NORMAL}
            hasEditorAccess={hasEditorAccess}
            id='mainHeader'
        >
            <AdminToolbar
                hasEditorAccess={hasEditorAccess}
                post={post}
                isPreview={isPreviewSheet || isPreviewNews}
                headerPageContentType={headerPageContentType}
                headerPageContentId={headerPageContentId}
            />

            <HeaderContainer
                hasEditorAccess={hasEditorAccess}
                isPreview={isPreviewSheet || isPreviewNews}
            >
                <CTAJotaPro
                    {...{ auth }}
                    showArticle={ctaPRO.enabled}
                    link={ctaPRO.link}
                    txtMobile={ctaPRO.textMobile}
                    txtNormal={ctaPRO.textLarge}
                />

                <HeaderBase {...{ auth, showAcessibility, pageTributos }} />

                {!pageTributos && (
                    <EditorialsComponent
                        {...{ auth, wpMenu, signupLink, pageTributos }}
                    />
                )}

                {ui.sidebar.isOpen && <HamburguerMenu {...{ wpMenu }} />}
                {bannerTop && (
                    <BannerTopComponent
                        {...bannerTop}
                        scroll={scrollPosition > SCROLL_LIMIT_NORMAL}
                    />
                )}
            </HeaderContainer>

            {router?.query?.fromPro && (
                <div
                    style={{
                        position: 'fixed',
                        top: scroll ? '7rem' : `${marginTop + 4}rem`
                    }}
                >
                    <AlertJota isLogged={isLogged} />
                </div>
            )}
        </HeaderStyle>
    )
}

export default HeaderComponent
